// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Facets$Showside from "../types/Facets.bs.js";
import * as Navbar$Showside from "./Navbar.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as UseIsPLP$Showside from "../hook/UseIsPLP.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as UseSidebar$Showside from "../hook/UseSidebar.bs.js";
import * as Breadcrumbs$Showside from "./Breadcrumbs.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as ListPageSort$Showside from "./ListPageSort.bs.js";
import * as SectionTitle$Showside from "./SectionTitle.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as FiltersBadges$Showside from "./FiltersBadges.bs.js";
import * as ProductsCount$Showside from "./ProductsCount.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as CustomerBombayShirts$Showside from "../customers/CustomerBombayShirts.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
import * as GridDensityZoomSelector$Showside from "./GridDensityZoomSelector.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
import * as UseCategoryDisplayPriority$Showside from "../hook/UseCategoryDisplayPriority.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function ListPageToolbar$Content(Props) {
  var category = Props.category;
  var topLevelCategories = Props.topLevelCategories;
  var listPageContentType = Props.listPageContentType;
  var isSidebarOpen = Props.isSidebarOpen;
  var show = Props.show;
  var isBombayshirts = CustomerBombayShirts$Showside.useIsBombay(undefined);
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var match$1 = ViewportContext$Showside.use(undefined);
  var isMobile = match$1.isMobile;
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var appliedFilters = match$2.productFilters;
  var appliedSort = match$2.productSort;
  var filtersConfig = Belt_Option.flatMap(match.transitiveAccount, function (account) {
    return account.filtersConfig2;
  });
  var isForcingPLP = UseCategoryDisplayPriority$Showside.useCategoryDisplayPriority(category) === /* ProductsFirst */1;
  var match$3 = EntrypointContext$Showside.use(undefined);
  var toggleFiltersPanel = match$3.toggleFiltersPanel;
  var toggleSidebar = match$3.toggleSidebar;
  var match$4 = GridDensityZoomProvider$Showside.use(undefined);
  var isPLP = UseIsPLP$Showside.useIsPLP(undefined);
  var isConnectedToStoreCategory = category !== undefined ? Category$Showside.ExternalConnection.isConnectedToStoreCategory(category) : Belt_Option.mapWithDefault(settings.indexNode, false, Category$Showside.ExternalConnection.isConnectedToStoreCategory);
  var match$5 = UseSidebar$Showside.isEnabled(category, settings, match$2.listPageType, isForcingPLP);
  var filtersEnabled = match$5[1] && Belt_Option.isSome(filtersConfig);
  var shouldShowFilters = (match$5[0] || filtersEnabled) && !isMobile;
  var shouldShowSorts = settings.filtersEnabled && isPLP && !isMobile && isConnectedToStoreCategory;
  var match$6 = settings.indexNode;
  var connection = category !== undefined ? Category$Showside.ExternalConnection.getStoreCategoryConnection(category) : match$6 !== undefined ? Category$Showside.ExternalConnection.getStoreCategoryConnection(match$6) : undefined;
  var match$7 = settings.indexNode;
  var category$1 = category !== undefined ? category : match$7 !== undefined ? match$7 : LegacyShowside_CategoryDecoders$ApiTypes.empty;
  var match$8 = GridDensityZoomProvider$Showside.use(undefined);
  var gridColumns = match$8.gridColumns;
  var shouldShowZoom = match$8.isZoomEnabled && isPLP;
  var zoomButton = Belt_Option.map(Belt_Option.keep(match$4.onChangeGridDensity, function (param) {
    return shouldShowZoom;
  }), function (onChangeGridDensity) {
    return React.createElement(GridDensityZoomSelector$Showside.make, {
      value: gridColumns,
      onChange: onChangeGridDensity
    });
  });
  var onClick = isBombayshirts ? function (param) {
    Curry._1(toggleFiltersPanel, undefined);
  } : function (param) {
    Curry._1(toggleSidebar, undefined);
  };
  var label = isBombayshirts ? "Filters" : isSidebarOpen ? "Hide Filters" : "Show Filters";
  var filtersButton;
  if (shouldShowFilters) {
    var tmp = {
      onClick: onClick,
      clear: true,
      iconSize: /* Small */3,
      labelSize: /* Small */3,
      icon: React.createElement(Unicons$Showside.UilSlidersVAlt.make, {
        size: /* Px */{
          _0: 20
        }
      }),
      iconFirst: false,
      noMargin: true,
      label: label,
      dataTestId: "navbar-button-sidebar",
      dataActive: isSidebarOpen,
      iconClassName: CSS$Showside.prefix("rotate-90 ml-2 transform-gpu"),
      labelClassName: CSS$Showside.prefix("font-medium")
    };
    var tmp$1 = Belt_Option.flatMap(Belt_Option.keep(Belt_Option.map(appliedFilters, Facets$Showside.length), function (num) {
      return num > 0;
    }), function (num) {
      return StringUtils$Showside.fromInt(99, undefined, num);
    });
    if (tmp$1 !== undefined) {
      tmp.badge = Caml_option.valFromOption(tmp$1);
    }
    filtersButton = Caml_option.some(React.createElement(IconButton$Showside.make, tmp));
  } else {
    filtersButton = undefined;
  }
  var sortsButton;
  if (shouldShowSorts) {
    var tmp$2 = {
      connection: connection,
      appliedSort: appliedSort
    };
    if (appliedFilters !== undefined) {
      tmp$2.appliedFilters = Caml_option.valFromOption(appliedFilters);
    }
    sortsButton = Caml_option.some(React.createElement("div", {
      className: CSS$Showside.prefix("flex space-x-6 relative")
    }, React.createElement(ListPageSort$Showside.make, tmp$2)));
  } else {
    sortsButton = undefined;
  }
  var tmp$3 = {};
  if (connection !== undefined) {
    tmp$3.connection = Caml_option.valFromOption(connection);
  }
  if (appliedFilters !== undefined) {
    tmp$3.appliedFilters = Caml_option.valFromOption(appliedFilters);
  }
  if (appliedSort !== undefined) {
    tmp$3.appliedSort = Caml_option.valFromOption(appliedSort);
  }
  var filtersBadges = React.createElement(FiltersBadges$Showside.make, tmp$3);
  var controls;
  var exit = 0;
  if (zoomButton !== undefined || filtersButton !== undefined || sortsButton !== undefined) {
    exit = 1;
  } else {
    controls = undefined;
  }
  if (exit === 1) {
    controls = Caml_option.some(isMobile ? Belt_Option.getWithDefault(zoomButton, null) : React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex justify-between items-center", isPLP ? "gap-7" : ""]))
    }, React.createElement("div", {
      className: CSS$Showside.prefix("flex items-center justify-end")
    }, Belt_Option.getWithDefault(zoomButton, null)), Belt_Option.getWithDefault(filtersButton, null), Belt_Option.getWithDefault(sortsButton, null)));
  }
  var breadcrumbs = Breadcrumbs$Showside.useBreadcrumbs(true, false, undefined, topLevelCategories);
  var show$1 = show && (isPLP || breadcrumbs.show || Belt_Option.isSome(controls));
  var tmp$4;
  if (isPLP) {
    var exit$1 = 0;
    if (typeof listPageContentType === "number") {
      if (listPageContentType !== 1) {
        if (listPageContentType !== 0) {
          exit$1 = 1;
        } else {
          tmp$4 = React.createElement(SectionTitle$Showside.make, {
            minimal: true,
            text: "Recently Viewed"
          });
        }
      } else {
        tmp$4 = React.createElement(SectionTitle$Showside.make, {
          minimal: true,
          text: "Favorites"
        });
      }
    } else {
      exit$1 = 1;
    }
    if (exit$1 === 1) {
      tmp$4 = React.createElement(ProductsCount$Showside.make, {
        category: category$1,
        className: CSS$Showside.prefix("text-lg float-left text-secondary"),
        format: function (count) {
          return "" + String(count) + " product" + (count !== 1 ? "s" : "") + "";
        },
        key: category$1.id
      });
    }
  } else {
    tmp$4 = breadcrumbs.show ? React.createElement(Breadcrumbs$Showside.Show.make, {
      hook: breadcrumbs
    }) : null;
  }
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: show$1,
    children: React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["py-3", "bg-main", "pointer-events-auto"]))
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex", "w-full", "items-center", "justify-between", "relative", isMobile ? "flex-wrap" : "flex-nowrap", isMobile ? "px-4" : "px-8"]))
    }, React.createElement("div", undefined, tmp$4), Belt_Option.getWithDefault(controls, null)), filtersBadges)
  });
}
ListPageToolbar$Content.displayName = "ListPageToolbar.Content";
var make = React.memo(ListPageToolbar$Content);
var Content = {
  make: make
};
function ListPageToolbar(Props) {
  var showOpt = Props.show;
  var anchorHookResult = Props.anchorHookResult;
  var category = Props.category;
  var listPageContentType = Props.listPageContentType;
  var isSidebarOpen = Props.isSidebarOpen;
  var topLevelCategories = Props.topLevelCategories;
  var show = showOpt !== undefined ? showOpt : true;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var match$2 = ListPageLayoutController$Showside.Context.use(undefined);
  var match$3 = match$2.state;
  var titleHeight = match$3.titleHeight;
  var subMenuSliderHeight = match$3.subMenuSliderHeight;
  var dynamicSecondaryNavbarHeight = match$3.dynamicSecondaryNavbarHeight;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, topLevelCategories);
  var primaryNavbarHeight = match$3.showPrimaryNavbar ? match$3.primaryNavbarHeight : 0;
  var offsetForStickyElements = StickyHeaderOffsetProvider$Showside.useEffective(undefined);
  var offsetForStickyElements$1 = match$1.embedType === /* Inline */1 ? offsetForStickyElements : 0;
  var offset = (primaryNavbarHeight + match$3.fixedSecondaryNavbarHeight | 0) + offsetForStickyElements$1 | 0;
  var ref = React.useRef(null);
  ListPageLayoutController$Showside.useToolbarHeightSetter(ref);
  var marginTop = Belt_Option.map(Belt_Option.keep(Belt_Option.keep(Belt_Option.keep(-dynamicSecondaryNavbarHeight | 0, function (param) {
    return subMenuSliderHeight !== 0;
  }), function (param) {
    return titleHeight >= dynamicSecondaryNavbarHeight;
  }), function (param) {
    return !isMobile;
  }), CSS$Showside.intToPx);
  var tmp = {
    top: CSS$Showside.intToPx(offset - 1 | 0)
  };
  if (marginTop !== undefined) {
    tmp.marginTop = marginTop;
  }
  var tmp$1 = {
    topLevelCategories: topLevelCategories,
    activeCategory: activeCategory,
    keepFixed: false
  };
  if (anchorHookResult !== undefined) {
    tmp$1.anchorHookResult = Caml_option.valFromOption(anchorHookResult);
  }
  var tmp$2 = {
    topLevelCategories: topLevelCategories,
    listPageContentType: listPageContentType,
    isSidebarOpen: isSidebarOpen,
    show: show
  };
  if (category !== undefined) {
    tmp$2.category = Caml_option.valFromOption(category);
  }
  return React.createElement(DataAttribute$Showside.make, {
    ariaLive: "polite",
    children: React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(ref),
      "aria-atomic": true,
      className: CSS$Showside.prefix(Cn.make(["smartnav-toolbar", "sticky", "relative", "w-full", "transition-top duration-300 z-10", "pointer-events-none"])),
      role: "toolbar",
      style: tmp
    }, React.createElement(Navbar$Showside.SecondaryNavbar.make, tmp$1), React.createElement(make, tmp$2))
  });
}
ListPageToolbar.displayName = "ListPageToolbar";
var make$1 = React.memo(ListPageToolbar);
export { Content, make$1 as make };
/* make Not a pure module */